export const SubscriptionStatus = {
  Pending: 'pending',
  Active: 'active',
  Trialing: 'trialing',
  Cancelled: 'cancelled'
} as const;

export type SubscriptionStatus = (typeof SubscriptionStatus)[keyof typeof SubscriptionStatus];

export const SubscriptionPlanCode = {
  Basic: 'basic',
  Advanced: 'advanced'
} as const;

export type SubscriptionPlanCode = (typeof SubscriptionPlanCode)[keyof typeof SubscriptionPlanCode];
